import { matchPath, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ROUTE_URLS } from "../../constants/consts";
import { SeoHead } from "./SeoHead";

type SeoConfig = {
  title: string;
  description: string;
  robots: string;
  canonicalPath?: string;
};

const KNOWN_ROUTE_PATTERNS = [
  ROUTE_URLS.HOME,
  ROUTE_URLS.CATALOG,
  ROUTE_URLS.CATALOG_CATEGORY,
  ROUTE_URLS.PRODUCT_FROM_CATEGORY,
  ROUTE_URLS.PRODUCT,
  ROUTE_URLS.CART,
  ROUTE_URLS.SIGN_IN,
  ROUTE_URLS.SIGN_UP,
  ROUTE_URLS.ORDERS,
  ROUTE_URLS.ORDER,
  ROUTE_URLS.RETURNS,
  ROUTE_URLS.RETURN,
  ROUTE_URLS.QUESTIONARY,
  ROUTE_URLS.INVOICES,
  ROUTE_URLS.CREDIT_LIMIT_HISTORY,
  ROUTE_URLS.NEW_CREDIT_LIMIT,
  ROUTE_URLS.CREDIT_LIMIT,
  ROUTE_URLS.CONTACT_INFORMATION,
  ROUTE_URLS.TERM_SERVICE,
  ROUTE_URLS.TWO_FACTOR_AUTH,
  ROUTE_URLS.WARRANTY_TERMS,
  ROUTE_URLS.WARRANTY_PERIODS,
  ROUTE_URLS.WARRANTY_CASE,
  ROUTE_URLS.WARRANTIES,
  ROUTE_URLS.WARRANTY,
  ROUTE_URLS.RECOVER_PASSWORD,
  ROUTE_URLS.RECOVER_PASSWORD_FORM,
  ROUTE_URLS.LANDING_PAGE,
  ROUTE_URLS.SHIPPING_QUOTE_PAGE,
  ROUTE_URLS.SHIPPING_REQUEST,
  ROUTE_URLS.IMAGE,
  "/search",
];

const matchesRoute = (pathname: string, patterns: string[]) =>
  patterns.some((pattern) => Boolean(matchPath(pattern, pathname)));

export const AppSeo = () => {
  const { pathname } = useLocation();
  const { t } = useTranslation();

  let seoConfig: SeoConfig = {
    title: t("seo.portal.title"),
    description: t("seo.portal.description"),
    robots: "noindex,nofollow",
  };

  if (matchesRoute(pathname, [ROUTE_URLS.LANDING_PAGE])) {
    seoConfig = {
      title: t("seo.landing.title"),
      description: t("seo.landing.description"),
      robots: "index,follow",
      canonicalPath: ROUTE_URLS.LANDING_PAGE,
    };
  } else if (matchesRoute(pathname, [ROUTE_URLS.SIGN_IN])) {
    seoConfig = {
      title: t("seo.sign_in.title"),
      description: t("seo.sign_in.description"),
      robots: "noindex,nofollow",
      canonicalPath: ROUTE_URLS.SIGN_IN,
    };
  } else if (matchesRoute(pathname, [ROUTE_URLS.SIGN_UP])) {
    seoConfig = {
      title: t("seo.sign_up.title"),
      description: t("seo.sign_up.description"),
      robots: "noindex,nofollow",
      canonicalPath: ROUTE_URLS.SIGN_UP,
    };
  } else if (
    matchesRoute(pathname, [
      ROUTE_URLS.RECOVER_PASSWORD,
      ROUTE_URLS.RECOVER_PASSWORD_FORM,
    ])
  ) {
    seoConfig = {
      title: t("seo.recover_password.title"),
      description: t("seo.recover_password.description"),
      robots: "noindex,nofollow",
      canonicalPath: ROUTE_URLS.RECOVER_PASSWORD,
    };
  } else if (!matchesRoute(pathname, KNOWN_ROUTE_PATTERNS)) {
    seoConfig = {
      title: t("seo.not_found.title"),
      description: t("seo.not_found.description"),
      robots: "noindex,nofollow",
    };
  }

  return <SeoHead {...seoConfig} />;
};
